import { useMemo, useState } from 'react';
import FlatListPane from './FlatListPane';
import TeamsTree from './TeamsTree';
import ExchangeRates from './ExchangeRates';

const NAV = [
  { id: 'department', label: 'Department', count: (l) => l.departments?.length || 0 },
  { id: 'teams', label: 'Teams & sub-teams', count: (l) => (l.teams?.length || 0) + (l.subTeams?.length || 0) },
  { id: 'countries', label: 'Countries', count: (l) => l.countries?.length || 0 },
  { id: 'skills', label: 'Skills', count: (l) => l.skills?.length || 0 },
  { id: 'suppliers', label: 'Suppliers', count: (l) => l.suppliers?.length || 0 },
  { id: 'fx', label: 'Exchange rates', count: (l) => l.fx?.length || 0 },
];

export default function ReferenceData({ lookups, orgId, profile, reload }) {
  const [active, setActive] = useState('teams');
  const [navSearch, setNavSearch] = useState('');
  const [error, setError] = useState(null);

  const filteredNav = useMemo(
    () => NAV.filter((item) => item.label.toLowerCase().includes(navSearch.trim().toLowerCase())),
    [navSearch],
  );

  const listCount = NAV.length;

  return (
    <div className="rd-shell">
      <aside className="rd-subnav">
        <h1>Reference data</h1>
        <p className="rd-sub">{listCount} lists</p>
        <div className="rd-search-wrap">
          <input
            type="search"
            className="form-input"
            placeholder="Search"
            value={navSearch}
            onChange={(e) => setNavSearch(e.target.value)}
          />
        </div>
        <nav className="rd-nav-list">
          {filteredNav.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`rd-nav-row${active === item.id ? ' active' : ''}`}
              onClick={() => setActive(item.id)}
            >
              {item.label}
              <span className="rd-cnt">{item.count(lookups)}</span>
            </button>
          ))}
        </nav>
      </aside>

      <div className="rd-content">
        {error && (
          <div className="form-error" style={{ marginBottom: 12 }}>
            {error} (Reference tables are editable by org admins only.)
          </div>
        )}

        {active === 'department' && (
          <FlatListPane paneId="department" items={lookups.departments} orgId={orgId} setError={setError} reload={reload} />
        )}
        {active === 'teams' && (
          <TeamsTree
            teams={lookups.teams}
            subTeams={lookups.subTeams}
            orgId={orgId}
            setError={setError}
            reload={reload}
          />
        )}
        {active === 'countries' && (
          <FlatListPane paneId="countries" items={lookups.countries} orgId={orgId} setError={setError} reload={reload} />
        )}
        {active === 'skills' && (
          <FlatListPane paneId="skills" items={lookups.skills} orgId={orgId} setError={setError} reload={reload} />
        )}
        {active === 'suppliers' && (
          <FlatListPane paneId="suppliers" items={lookups.suppliers} orgId={orgId} setError={setError} reload={reload} />
        )}
        {active === 'fx' && (
          <ExchangeRates fx={lookups.fx} orgId={orgId} profile={profile} setError={setError} reload={reload} />
        )}
      </div>
    </div>
  );
}
